import type { AgentAttachment } from '@multiplayer-app/ai-agent-types'
import { useAgentStore } from '@/context/AgentProvider'
import { getChatState } from '@/state/useAgentStore'

export interface ComposerDraft {
  value: string
  attachments: AgentAttachment[]
}

/**
 * Public API for host apps to read/write the current composer draft (value + attachments),
 * including adding context attachments from anywhere in the UI.
 */
export const useComposerDraft = () => {
  const chatKey = useAgentStore((s) => s.activeChatId ?? s.draftChatKey)
  const draft = useAgentStore((s) => getChatState(s, chatKey).composerDraft)
  const setComposerValue = useAgentStore((s) => s.setComposerValue)
  const setComposerDraft = useAgentStore((s) => s.setComposerDraft)
  const clearComposerDraft = useAgentStore((s) => s.clearComposerDraft)
  const addComposerAttachments = useAgentStore((s) => s.addComposerAttachments)
  const removeComposerAttachment = useAgentStore((s) => s.removeComposerAttachment)

  return {
    chatKey,
    draft,
    setValue: (value: string) => setComposerValue(chatKey, value),
    setDraft: (next: ComposerDraft) => setComposerDraft(chatKey, next),
    clearDraft: () => clearComposerDraft(chatKey),
    addAttachments: (attachments: AgentAttachment[]) => addComposerAttachments(chatKey, attachments),
    removeAttachment: (attachmentId: string) => removeComposerAttachment(chatKey, attachmentId)
  }
}
